/**
 * Default language dictionary
 */
const defaultLanguage = {
  chat: 'Chat',
  participants: 'Participants',
  polls: 'Polls',
  plugins: 'Plugins',
  mic_off: 'Mic Off',
  mic_on: 'Mic On',
  video_off: 'Video Off',
  video_on: 'Video On',
  left_meeting: 'You left the meeting',
  share_screen_start: 'Share Screen',
  share_screen_stop: 'Stop Sharing',
  leave: 'Leave',
  dismiss: 'Dismiss',
  page: 'Page',
  settings: 'Settings',
  audio: 'Audio',
  video: 'Video',
  connection: 'Connection',
  leave_confirmation: 'Are you sure you want to leave the call?',
  end_meeting_for_all: 'End meeting for all',
  cancel: 'Cancel',
  mute: 'Mute',
  kick: 'Kick',
  'participant.turn_off_video': 'Turn off video',
  perm_browser_denied: 'Permission denied by browser',
  'perm.sys_denied.message': "To enable system permission, go to Mac's System Preferences -> Security & Privacy ->  Privacy -> Select Microphone, Camera or 'Screen Recording' and allow permission for your specific browser",
  perm_sys_denied: 'Permission denied by system',
  perm_denied_title: 'Camera and mic permissions denied',
  perm_denied_text: 'It seems like your browser or system has blocked permissions for us to access camera, microphone. Please allow these permissions and reload for a smoother experience.',
  full_screen: 'Full Screen',
  'full_screen.exit': 'Exit Full Screen',
  'waitlist.header_title': 'Waiting',
  'waitlist.body_text': 'You are in the waiting room, the host will let you in soon.',
  'waitlist.deny_request': 'Deny request',
  'waitlist.accept_request': 'Accept request',
  'waitlist.accept_all': 'Accept all',
  'stage_request.header_title': 'Join Stage Requests',
  'stage_request.deny_request': 'Deny request',
  'stage_request.accept_request': 'Accept request',
  'stage_request.accept_all': 'Accept all',
  'stage_request.deny_all': 'Deny all',
  'stage_request.approval_pending': 'Pending',
  'stage_request.denied': 'Denied',
  'stage_request.request': 'Join stage',
  'stage_request.leave_stage': 'Leave stage',
  'stage_request.request_tip': 'Request to join the discussion',
  'stage_request.leave_tip': 'Leave the stage',
  'stage_request.pending_tip': 'Request pending',
  'stage_request.denied_tip': 'Rejected request',
  'stage.empty_host': 'The stage is empty',
  'stage.empty_host_summary': 'To begin the webinar, please join the stage or accept a join stage request from the participants tab.',
  'stage.empty_viewer': 'Webinar has not yet been started',
  'stage.remove_from_stage': 'Remove from stage',
  'stage.add_to_stage': 'Add to stage',
  'stage.join_title': 'Joining webinar stage',
  'stage.join_summary': 'Upon joining the stage, your video & audio as shown above will be visible to all participants.',
  'stage.join_cancel': 'Cancel',
  'stage.join_confirm': 'Confirm & Join stage',
  'setup_screen.join_in_as': 'Join in as',
  'setup_screen.joining_as': 'Joining as',
  'setup_screen.your_name': 'Your name',
  'stage.reconnecting': 'Reconnecting...',
};

export { defaultLanguage as d };
